import React, { useCallback } from 'react';
import fecha from 'fecha';

import TrainWeeklySchedule from '../../components/TrainWeeklySchedule';

import { WeeklyTrainInfo, RouteInfoData } from '../../types';
import { isMobile } from '../../../utils/commonUtils';
import { onTrainExtraClickedType } from '../RouteInfoContext';
import { getPageSectionName } from '../../../utils/getPageSectionName';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';

function format24To12h(time: string) {
  const timeParsed = fecha.parse(time, 'HH:mm');
  return timeParsed ? fecha.format(timeParsed, 'h:mm A') : '';
}
type TrainListItemProps = {
  train: WeeklyTrainInfo;
  trainsData: RouteInfoData;
  onClick: (config: onTrainExtraClickedType) => void;
  stationUrlMap: any;
  pageName: string;
};

export function TrainListItem({ train, trainsData, onClick, stationUrlMap, pageName }: TrainListItemProps) {
  const [departTime, departTimeMeridian] = format24To12h(train.departureTime).split(' ');
  const [arrivalTime, arrivalTimeMeridian] = format24To12h(train.arrivalTime).split(' ');
  const { stationMap } = trainsData;
  const fromStnName = (stationMap[train.fromStnCode] && stationMap[train.fromStnCode].name) || '';
  const toStnName = (stationMap[train.toStnCode] && stationMap[train.toStnCode].name) || '';
  const onTrainClickCallback = useCallback(() => {
    onClick({
      fromCityEn: train.fromCityNameEng,
      toCityEn: train.toCityNameEng,
      isMobile: isMobile(),
      fromCity: train.fromCityName,
      fromStn: train.fromStnCode,
      toCity: train.toCityName,
      toStn: train.toStnCode,
      trainNumber: train.trainNumber
    });
  }, []);

  const pageSectionName = getPageSectionName(pageName);
  return (
    <div className="positionRelative">
      <li
        className="trainList loaderOnClick"
        tabIndex={0}
        onClick={() => {
          if (pageName) trackClickEventProp61(pageName, `rail_seo_${pageSectionName}_trainroutecard_clicked`);
          onTrainClickCallback();
        }}
      >
        <div className="trainInfo">
          <p className="trainNameNum">
            <a onClick={(e) => e.preventDefault()} href={train.trainPageUrl} className="trainName">
              {train.trainName}
            </a>{' '}
            <span className="trainNumber">#{train.trainNumber}</span>
          </p>
          <p className="departsDays">
            <span className="prependRight5">Departs on:</span>
            <TrainWeeklySchedule trainSchedule={train} />
          </p>
        </div>

        <div className="timeStation">
          <div className="startDepartTime">
            <span className="timeText">
              {departTime}
              <span className="timeDayText"> {departTimeMeridian} </span>
            </span>
            <span className="stationCode">{train.fromStnCode}</span>
            {fromStnName && (
              <a onClick={(e) => e.preventDefault()} href={stationUrlMap[train.fromStnCode]} className="stationName">
                {fromStnName}
              </a>
            )}
          </div>

          <div className="travelTimeStop">
            <span className="travelHrs">
              {train.durationParts.map(({ value, unit }) => (
                <span className={'durationPart'} key={`${value}_${unit}`}>
                  <span className={'value'}>{value}</span>
                  <span className={'unit'}>{unit}</span>
                </span>
              ))}
            </span>
            <span className="timeStopBdr" />
            <span className="travelHrs">
              <span className={'durationPart'}>
                <span className={'value'}>{`${train.distance} kms`}</span>
              </span>
            </span>
          </div>
          <div className="startDepartTime">
            <span className=" timeText">
              {arrivalTime}
              <span className="timeDayText"> {arrivalTimeMeridian}</span>
            </span>
            <span className="stationCode ">{train.toStnCode}</span>
            {toStnName && (
              <a onClick={(e) => e.preventDefault()} href={stationUrlMap[train.toStnCode]} className="stationName">
                {toStnName}
              </a>
            )}
          </div>
        </div>
        <div
          style={{ width: '127px', textAlign: 'center' }}
          className="bluePrimarybtn selectDateBtn pushRight"
          onClick={onTrainClickCallback}
        >
          <span> {trainsData.miscellaneous['SELECT DATE']}</span>
        </div>
      </li>
    </div>
  );
}
